import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from 'src/app/config/api.service';
import * as redemptionActions from '../actions/redemptions.action';

@Injectable()

export class RedemptionsEffects{
  constructor(
    private actions$: Actions,
    private ApiService: ApiService
  ){}

  loadRedemptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(redemptionActions.getRedemptions),
      switchMap((action) =>
        this.ApiService.getRedemptions(action.params).pipe(
          map(response => redemptionActions.redemptionsSuccess(response)),
          catchError((error: any) => of(redemptionActions.redemptionsFailure(error))))
      )
    ),{dispatch: true}
  );
}
